

import React, { useState, useEffect, useRef } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  TextField,
  Button,
  Box,
  useMediaQuery,
  IconButton,
  Tooltip,
  Typography,
  DialogTitle,
} from "@mui/material";
import { DataGrid, GridColDef, GridFilterModel } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { axiosInstance } from "../../utility/apiInstance";
import EditIcon from "@mui/icons-material/Edit";
import DialogBox from "./DialogBox";
import ModalPopup from "../../common/ModalPopup";
import SubscriptionForm from "../../components/ManageSubscription/SubscriptionForm";
import Milestone from "../../components/ManageSubscription/MileStone";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useNavigate, useSearchParams } from "react-router-dom";
import chroma from "chroma-js";
import Select, { StylesConfig } from "react-select";
import Loading from "../../components/AWBDashboard/Loading";
import AddMilestoneGroupingForm from "../../components/ManageSubscription/AddMilestoneGroupingForm";
import AddcustomfieldsForm from "../../components/AddcustomfieldsForm";
import { OptionType } from "dayjs";
import toast from "react-hot-toast";
import { useRole } from "../../components/MangeContextProvide";
import AirShippingShowModal from "../../components/AWBDashboard/ShowShipping";
import { convertArray } from "../../components/AWBDashboard/customFieldtConvert";

const defaultTheme = createTheme();

interface TagOption {
  value: string;
  label: string;
  color: string;
  description?: string;
}

interface FieldData {
  id: string;
  autocompleteValue: OptionType | null;
  textValue: string | string[];
  value?: string | string[];
  required?: boolean;
  label?: string;
  isUnique?: boolean;
}

interface AirLinesType {
  _id: string;
  airlineCode: string;
  airlineName: string;
  airlineTwolettercode: string;
}

const dot = (color = "transparent") => ({
  alignItems: "center",
  display: "flex",
  ":before": {
    backgroundColor: color,
    borderRadius: 10,
    content: '" "',
    display: "block",
    marginRight: 8,
    height: 10,
    width: 10,
  },
});


const AwbTrackedListPage = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [awbs, setAwbs] = useState("");
  const [trackingList, setTrackingList] = useState([]) as any;
  const [error, setError] = useState<string | null>(null);
  const [errorList, setErrorList] = useState(null);
  const [show, setShow] = useState(false);
  const [modalPopup, setmodalPopup] = useState({
    subcriptionPopup: false,
    mileStonePopup: false,
    groupmilestoneModal: false,
    customfieldpopup: false,
  });
  const [statusMessage, setStatusMessage] = useState({}) as any;
  const [filter, setFilter] = useState({}) as any;
  const [subscriptionFormData, setSubscriptionFormData] = useState<any>({
    whatsApp: [],
    emails: [],
    whatsAppmilestones: [],
    emailsmilestones: [],
    milestoneList: [],
    mileStoneType: "",
    manageContactList: [],
    templateList: [],
    whatsappGroupList: [],
    whatsAppgroups: [],
    whatsappGroupmilestones: [],
    groupMilestone: "",
    flags: [],
    flagsList: [],
    contactOrganization: "",
  });
  const [options, setOptions] = React.useState<TagOption[]>([]);
  const [selectedOption, setSelectedOption] = React.useState<TagOption | null>(null);
  const [open, setOpen] = useState(false);
  const [airLines, setAirLines] = useState<AirLinesType[]>([]);
  const [loading, setLoading] = React.useState(false);
  const { milestoneList, manageContactList } = subscriptionFormData;
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
  const [totalCount, setTotalCount] = useState(0);
  const [allField, setAllField] = useState([]);
  const [fields, setFields] = useState<any>([
    { id: "1", autocompleteValue: null, textValue: "" },
  ]);
  const [errors, setErrors] = useState<{
    [key: string]: { autocomplete: boolean; text: boolean };
  }>({});
  const [dataArray, setDataArray] = useState<FieldData[]>([]);
  const [subscriptiondata, setSubscriptionData] = useState([]);
  const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});

  const { chargeRate, availableCredit, masterCustomFields } = useRole() as any;
  const isLowBalance = availableCredit <= 0 || availableCredit < chargeRate.awbRate;

  const loadingRef = useRef(false);
  const dataGridRef = useRef<any>(null);
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const navigate = useNavigate();

  const getCustomForms = async () => {
    try {
      const { data } = await axiosInstance.get("/api/v1/custom-form/admin-fields");
      setAllField(data.data);
      setFields(data.data.map((item: any, i: number) => ({
        id: String(i + 1),
        autocompleteValue: {
          id: i + 1,
          label: item.fieldName,
          required: item.required,
          customFieldId: item._id,
          isUnique: item.isUnique,
        },
        textValue: "",
        label: item.fieldName,
        value: "",
        required: item.required,
        customFieldId: item._id,
        isUnique: item.isUnique,
      })));
    } catch (error: any) {
      throw error;
    }
  };

  const simpleOptions: any = allField.map((item: any, index: number) => ({
    id: index + 1,
    label: item.fieldName,
    required: item.required,
  }));

  const Fieldstype = allField.map((item: any, index: number) => {
    let f_type: string = "";
    switch (item.fieldType) {
      case "Text Box": f_type = "Textbox"; break;
      case "Dropdown List": f_type = "select"; break;
      case "Yes/No": f_type = "select"; break;
      case "Number": f_type = "Textbox"; break;
      case "Date": f_type = "Date"; break;
      default: f_type = "Textbox";
    }
    let fieldOptions: any[] = [];
    if (item.fieldType === "Dropdown List") {
      fieldOptions = (item.dropdownOptions as any[]).map((opt: any, idx: number) => ({
        id: idx + 1,
        label: opt,
      }));
    } else if (item.fieldType === "Yes/No") {
      fieldOptions = [{ id: 1, label: "Yes" }, { id: 2, label: "No" }];
    }
    return {
      id: index + 1,
      f_name: item.fieldName,
      f_type,
      default_value: "",
      is_required: item.required ? 1 : 0,
      options: fieldOptions,
    };
  });

  const getAllMileStone = async () => {
    try {
      let response = await axiosInstance.get("/api/v1/mileStone");
      setSubscriptionFormData((prev: any) => ({ ...prev, milestoneList: response?.data }));
    } catch (err) { }
  };

  const whatsappGroup = async () => {
    try {
      let response = await axiosInstance.get("/api/v1/whatsapp-group");
      setSubscriptionFormData((prev: any) => ({ ...prev, whatsappGroupList: response?.data?.data }));
    } catch (error) { }
  };

  const getAllTag = async () => {
    try {
      let response = await axiosInstance.get("/api/v1/tag");
      const transformedOptions =
        response?.data?.data?.map((tag: any) => ({
          value: tag._id,
          label: tag.name,
          color: tag.colorCode,
          description: tag.description,
        })) || [];
      setOptions(transformedOptions);
    } catch (err: any) { }
  };

  const getAllAilines = async () => {
    try {
      const response = await axiosInstance.get("api/v1/allowed-airline");
      if (response.status === 200 && response.data.success) setAirLines(response.data.data);
    } catch (err) {
      setAirLines([]);
    }
  };

  const fetchAllFlag = async () => {
    try {
      const { data } = await axiosInstance.get(`/api/v1/flags`);
      let finaldata = data.data
        .filter((flag: any) => flag.status === "Active")
        .map((flag: any) => {
          let flagId = flag.id;
          delete flag.id;
          return { ...flag, _id: flagId };
        });
      setSubscriptionFormData((prev: any) => ({ ...prev, flagsList: finaldata || [] }));
    } catch (error) {
      setSubscriptionFormData((prev: any) => ({ ...prev, flagsList: [] }));
    }
  };

  React.useEffect(() => {
    getAllTag();
    getAllAilines();
    getAllMileStone();
    whatsappGroup();
    fetchAllFlag();
    getCustomForms();
  }, []);

  const getTrackList = async (page: number, pageSize: number, filter = "") => {
    loadingRef.current = true;
    try {
      let response = await axiosInstance.post(
        status != null
          ? `/api/v1/awb-tracked-list?status=${status}&page=${page + 1}&size=${pageSize}&${filter}`
          : `/api/v1/awb-tracked-list?page=${page + 1}&size=${pageSize}&${filter}`
      );
      setTotalCount(response.data.data.count);
      return response.data.data?.data;
    } catch (err) {
      return [];
    } finally {
      loadingRef.current = false;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = await getTrackList(
        paginationModel.page,
        paginationModel.pageSize,
        filter.fieldName ? `${filter.fieldName}=${filter.value}` : ""
      );
      setTrackingList(data);
    };
    fetchData();
  }, [show, status, paginationModel.page, paginationModel.pageSize, filter]);

  const onFilterChange = React.useCallback(async (filterModel: GridFilterModel) => {
    const data = filterModel?.items[0];
    if (data?.value) {
      setFilter({ fieldName: data.field, value: data.value });
    } else {
      setFilter({ fieldName: "", value: "" });
    }
  }, []);

  // awbs: null      → single null-AWB shipment (no tracking number yet)
  // awbs: string[]  → normal array of AWB strings
  const buildAirPayload = (awbsValue: string[] | null) => {
    const { whatsAppmilestones, emailsmilestones, whatsappGroupmilestones } = subscriptionFormData;
    const whatApps = subscriptionFormData.whatsApp?.map((item: any) => item.value);
    const emails = subscriptionFormData.emails?.map((item: any) => item.value);
    const whatsappGroups = subscriptionFormData.whatsAppgroups?.map((item: any) => item.value);
    const tagId = selectedOption?.value || null;
    const groupMilestone = subscriptionFormData.groupMilestone?.value || null;
    const flags = subscriptionFormData.flags.map((el: any) => el.value);
    const contactOrganization = subscriptionFormData?.contactOrganization?.value || "";
    const customerName = subscriptionFormData?.customerName?.item?.name || null;

    return {
      awbs: awbsValue,
      whatApps,
      emails,
      whatsAppmilestones,
      emailsmilestones,
      whatsappGroups,
      whatsappGroupMilestones: whatsappGroupmilestones,
      tag: tagId,
      groupMilestone,
      flags,
      contactOrganization,
      customfields: convertArray(fields),
      customerName,
    };
  };

  const resetFields = () => {
    setAwbs("");
    setSelectedOption(null);
    setSubscriptionFormData((prev:any)=>({
      ...prev,
      whatsApp: [], emails: [], whatsAppmilestones: [], emailsmilestones: [],
      mileStoneType: "", whatsAppgroups: [], whatsappGroupmilestones: [],
      groupMilestone: { _id: "" }, flags: [],
      customerName: null,
    }));
    setFields(
      allField.map((item: any, i: number) => ({
        id: String(i + 1),
        autocompleteValue: {
          id: i + 1,
          label: item.fieldName,
          required: item.required,
          customFieldId: item._id,
          isUnique: item.isUnique,
        },
        textValue: "",
        label: item.fieldName,
        value: "",
        required: item.required,
        customFieldId: item._id,
        isUnique: item.isUnique,
      }))
    );
  };

  // ── Subscribe ──────────────────────────────────────────────────────────────
  // awbs === ""  →  null-AWB shipment: send awbs: null
  //               server validates that a unique custom field is present
  // awbs !== ""  →  normal array of AWB strings
  const handleSubscribe = async () => {
    const isNullAwb = !awbs.trim();

    // For null-AWB mode: at least one isUnique custom field must have a value
    if (isNullAwb) {
      const hasUniqueFilled = fields.some(
        (f: FieldData) => f.isUnique && f.value !== "" && f.value !== undefined
      );
      if (!hasUniqueFilled) {
        toast.error("Please fill at least one Unique custom field, or enter an AWB number.");
        return;
      }
    }

    try {
      const payload = isNullAwb
        ? buildAirPayload(null)              
        : buildAirPayload(awbs.split(","));  

      const response = await axiosInstance.post("/api/v1/airwaybill/add-airwaybill", payload);
      setSubscriptionData(response?.data?.data?.success);
      setStatusMessage(response?.data?.message);

      if (response.data.success) {
        setErrorList(
          response?.data?.data?.failed?.length > 0 ? response.data.data.failed : null
        );
        setShow(true);
        if (response?.data?.data?.failed?.length === 0) {
          resetFields();
        }
      }
    } catch (error: any) {
      setStatusMessage({});
      if (error?.response?.data?.error?.length > 0) {
        const errorlog = Array.isArray(error?.response?.data?.error)
          ? error?.response?.data?.error?.map((err: any) => ({ awb: "", reason: err?.message }))
          : [{ awb: "", reason: error?.response?.data?.error }];
        setErrorList(errorlog as any);
        setShow(true);
      }
    }
  };

  const handleOkClick = async () => {
    const newFieldErrors: Record<string, string> = {};
    for (const field of fields) {
      if (!field.required) continue;
      const isEmpty =
        field.value === "" ||
        field.value === undefined ||
        (Array.isArray(field.value) && field.value.length === 0);
      if (isEmpty) {
        newFieldErrors[field.id] = `${field.label} is required`;
      }
    }
    if (Object.keys(newFieldErrors).length > 0) {
      setFieldErrors(newFieldErrors);
      return;
    }

    const validFields: FieldData[] = fields.filter(
      (f: any) => f.autocompleteValue || f.textValue
    );
    setmodalPopup((prev) => ({ ...prev, customfieldpopup: false }));
    if (validFields.length === 0) return;
    setDataArray(validFields);
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    const inputValue = event.target.value;
    const nativeEvent = event.nativeEvent as InputEvent;
    if (
      nativeEvent.inputType === "deleteContentBackward" ||
      nativeEvent.inputType === "deleteByCut"
    ) {
      setAwbs((prevValue) => (inputValue.trim() === "" ? "" : prevValue.slice(0, -1)));
      return;
    }
    if (inputValue.trim() === "") { setAwbs(""); return; }

    let formattedValue = inputValue
      .replace(/[\r\n]+/g, ",")
      .replace(/\s*,\s*/g, ",")
      .replace(/[^0-9,]/g, "")
      .trim();

    formattedValue = formattedValue
      .split(",")
      .filter((awb) => awb.trim() !== ",")
      .map((awb) => {
        if (nativeEvent.inputType !== "insertText") {
          if (awb.length === 9) awb = "00" + awb;
          else if (awb.length === 10) awb = "0" + awb;
        }
        if (awb.length > 3 && awb[3] !== "-") awb = awb.slice(0, 3) + "-" + awb.slice(3);
        return awb;
      })
      .join(",");

    setAwbs(formattedValue);
  };

  const handleRedirect = () => navigate("/csvbulkupload");

  const handleIconClick = (row: any) => {
    navigate(`/trackingDetail?trackingId=${row.awbNumber}`);
  };

  const isValidAWB = (awb: string) => /^\d{3}-\d{8}$/.test(awb);

  const formatDate = (dateString: string | number | Date) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const columns: GridColDef[] = [
    { field: "index", headerName: "S.No.", disableColumnMenu: true, width: 70 },
    { field: "airlineName", headerName: "AIRLINE", width: isMobile ? 130 : 160 },
    { field: "addedByName", headerName: "Addded By", width: isMobile ? 120 : 150 },
    { field: "awbNumber", headerName: "MAWB", width: isMobile ? 140 : 130 },
    {
      field: "creationDate",
      headerName: "Added Date",
      width: isMobile ? 150 : 120,
      filterOperators: [
        {
          label: "On",
          value: "equals",
          getApplyFilterFn: (filterItem) => {
            if (!filterItem.value) return null;
            return (params) => {
              if (!params) return false;
              return formatDate(params) === formatDate(filterItem.value);
            };
          },
          InputComponent: ({ item, applyValue }) => (
            <div style={{ padding: "8px" }}>
              <input
                type="date"
                onChange={(e) => applyValue({ ...item, value: e.target.value })}
                value={item.value || ""}
              />
            </div>
          ),
        },
      ],
      renderCell: (params) => formatDate(params.row?.creationDate),
    },
    {
      field: "flightDate",
      headerName: "Flight Date",
      width: isMobile ? 150 : 120,
      disableColumnMenu: true,
      filterOperators: [
        {
          label: "On",
          value: "equals",
          getApplyFilterFn: (filterItem) => {
            if (!filterItem.value) return null;
            return (params) => {
              if (!params) return false;
              return formatDate(params) === formatDate(filterItem.value);
            };
          },
          InputComponent: ({ item, applyValue }) => (
            <div style={{ padding: "8px" }}>
              <input
                type="date"
                onChange={(e) => applyValue({ ...item, value: e.target.value })}
                value={item.value || ""}
              />
            </div>
          ),
        },
      ],
      renderCell: (params) => formatDate(params.row.flightDate),
    },
    { field: "origin", headerName: "Origin", width: isMobile ? 110 : 80 },
    { field: "destination", headerName: "Destination", width: isMobile ? 150 : 120 },
    { field: "trackingStatus", headerName: "Status", width: 250 },
    {
      field: "MILESTONE",
      headerName: "miletone",
      width: 140,
      disableColumnMenu: true,
      renderHeader: () => <Box display="flex" alignItems="center">miletone</Box>,
      renderCell: (params: any) => {
        const isTrackingAvailable = params?.row?.isTrackingAvailable;
        return (
          <Tooltip title={!isTrackingAvailable ? "No Status Available" : ""} arrow>
            <span>
              <IconButton
                disabled={!isTrackingAvailable}
                onClick={() => handleIconClick(params.row)}
                sx={{ cursor: !isTrackingAvailable ? "not-allowed" : "pointer" }}
              >
                <RemoveRedEyeOutlinedIcon />
              </IconButton>
            </span>
          </Tooltip>
        );
      },
    },
  ];

  // hint shown below the text field when no AWB is entered
  const isNullAwbMode = !awbs.trim();

  return (
    <>
      <div className="old_dashboard_title">
        <h1 className="text-2xl font-bold text-gray-700 mt-[-15px] mb-[10px]">
          Manage AWB's
        </h1>
      </div>
      <ThemeProvider theme={defaultTheme}>
        <div className="whiteBoxnew mb-6">
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 lg:col-span-9 md:col-span-9 sm:col-span-12">
              <div className="awbtextBox">
                <TextField
                  className="awbinput"
                  required
                  id="outlined-basic"
                  label="Add AWB(s), to add multiple use comma between each AWB"
                  variant="outlined"
                  value={awbs}
                  onChange={handleInputChange}
                  fullWidth
                  multiline
                  minRows={3}
                  disabled={isLowBalance}
                />
                {isLowBalance && (
                  <Typography variant="body2" color="error" sx={{ mt: 1, fontWeight: 500 }}>
                    Your account balance is low. Please add money to your account to
                    continue adding new tracking numbers.
                  </Typography>
                )}
                {/* hint when textarea is empty */}
                {isNullAwbMode && !isLowBalance && (
                  <Typography variant="body2" sx={{ mt: 0.5, color: "#888", fontSize: 12 }}>
                    No AWB? Fill a <strong>Unique</strong> custom field and click Subscribe.
                  </Typography>
                )}
              </div>

              <div className="awbBtnBox mt-1">
                <div className="text-right">
                  <button
                    onClick={handleOpen}
                    className="text-blue-700 text-sm hover:underline hover:text-yellow-500"
                  >
                    Check list of available airlines
                  </button>
                </div>
              </div>

              <AirShippingShowModal open={open} handleClose={handleClose} airLines={airLines} />
            </div>

            <div className="col-span-12 lg:col-span-3 md:col-span-3 sm:col-span-12">
              <div className="uploadbtn ml-0 lg:ml-10 md:ml-10 sm:ml-0">
                <h3 className="font-bold text-lg">Upload</h3>
                <p className="text-base text-gray-500 mb-2">File format: CSV only</p>
                <button onClick={handleRedirect} className="btn btnTheme px-6 py-2">
                  <FileUploadIcon className="btn btnTheme" />
                  Upload
                </button>
              </div>
            </div>

            <div className="col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
              <div className="w-full">
                <Button
                  variant="contained"
                  className="btn btnTheme ml3 mt-3"
                  onClick={() =>
                    setmodalPopup((prev) => ({ ...prev, subcriptionPopup: true }))
                  }
                >
                  {subscriptionFormData?.whatsAppmilestones.length > 0 ||
                    subscriptionFormData.emailsmilestones.length > 0
                    ? `whatsApp ${subscriptionFormData?.whatsAppmilestones.length} emails ${subscriptionFormData?.emailsmilestones.length} whatsappGroups ${subscriptionFormData?.whatsappGroupmilestones?.length}`
                    : "Manage Channels"}
                  <EditIcon sx={{ marginLeft: "10px" }} />
                </Button>
                <Button
                  variant="contained"
                  className="btn btnTheme ml3 mt-3"
                  onClick={() =>
                    setmodalPopup((prev) => ({ ...prev, groupmilestoneModal: true }))
                  }
                >
                  {(subscriptionFormData?.groupMilestone?.value || "").length > 0
                    ? `${subscriptionFormData?.groupMilestone?.item?.groupName || ""}`
                    : "Add Milestone Grouping"}
                </Button>
                <Button
                  variant="contained"
                  className="btn btnTheme ml3 mt-3"
                  onClick={() => setmodalPopup(p => ({ ...p, customfieldpopup: true }))}
                >
                  {convertArray(fields).length > 0
                    ? "✓ Custom field selected"
                    : isNullAwbMode
                      ? "⚠ Add Unique custom field"
                      : "Add custom field values"}
                </Button>
                <Button
                  variant="contained"
                  className="btn btnTheme btnGray"
                  onClick={handleSubscribe}
                >
                  Subscribe
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="whiteBox relative">
          <Paper component="form" sx={{ height: 430, width: "100%" }}>
            {loading ? (
              <Loading />
            ) : (
              trackingList?.length >= 0 && (
                <DataGrid
                  ref={dataGridRef}
                  loading={loadingRef.current}
                  rows={trackingList.map((item: any, index: number) => ({
                    ...item,
                    index: index + 1 + paginationModel.page * paginationModel.pageSize,
                    airlineName: item?.airline?.airlineName,
                    addedByName: item?.addedBy?.name,
                    flightDate: item?.flightsEtdEta[0]?.flightDate,
                  }))}
                  filterMode="server"
                  onFilterModelChange={onFilterChange}
                  columns={columns}
                  getRowId={(row) => row._id}
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                  pageSizeOptions={[10, 25, 50]}
                  rowCount={totalCount}
                  paginationMode="server"
                  sx={{ border: 0 }}
                />
              )
            )}
          </Paper>
        </div>

        {error && (
          <Box mt={3} sx={{ color: "red", marginLeft: "30px" }}>
            {error}
          </Box>
        )}
      </ThemeProvider>

      <DialogBox
        open={show}
        successMessage={
          <DialogTitle>
            <Typography
              variant="h6"
              className={`font-semibold ${statusMessage?.messageStatus === 1 ? "text-green-500" : "text-red-500"}`}
            >
              {statusMessage?.message}
            </Typography>
          </DialogTitle>
        }
        handleClose={() => { setShow(false); setErrorList(null); }}
        data={errorList}
      />

      <ModalPopup
        open={modalPopup.subcriptionPopup || modalPopup.mileStonePopup}
        handleClose={() =>
          setmodalPopup((prev) => ({ ...prev, subcriptionPopup: false, mileStonePopup: false }))
        }
        heading={""}
      >
        {modalPopup.subcriptionPopup ? (
          <SubscriptionForm
            editData={{}}
            subscriptionFormData={subscriptionFormData}
            manageContactList={manageContactList}
            setmodalPopup={setmodalPopup}
            setSubscriptionFormData={setSubscriptionFormData}
            whatsappGroupList={subscriptionFormData.whatsappGroupList}
          />
        ) : (
          <Milestone
            subscriptionFormData={subscriptionFormData}
            milestoneList={milestoneList}
            setSubscriptionFormData={setSubscriptionFormData}
            onclose={() =>
              setmodalPopup((prev) => ({ ...prev, subcriptionPopup: true, mileStonePopup: false }))
            }
          />
        )}
      </ModalPopup>

      <ModalPopup
        open={modalPopup.groupmilestoneModal}
        handleClose={() =>
          setmodalPopup((prev) => ({ ...prev, groupmilestoneModal: false }))
        }
        heading={""}
      >
        {modalPopup.groupmilestoneModal && (
          <AddMilestoneGroupingForm
            editData={{}}
            subscriptionFormData={subscriptionFormData}
            type="air"
            setmodalPopup={setmodalPopup}
            setSubscriptionFormData={setSubscriptionFormData}
          />
        )}
      </ModalPopup>

      <ModalPopup
        open={modalPopup.customfieldpopup}
        handleClose={() => {
          setmodalPopup((prev) => ({ ...prev, customfieldpopup: false }));
          setFieldErrors({});
        }}
        heading={"Manage Custom Fields"}
      >
        {modalPopup.customfieldpopup && (
          <div className="flex flex-col">
            <AddcustomfieldsForm
              simpleOptions={simpleOptions}
              Fieldstype={Fieldstype}
              setmodalPopup={setmodalPopup}
              fields={fields}
              setFields={setFields}
              errors={errors}
              setErrors={setErrors}
              setDataArray={setDataArray}
              fieldErrors={fieldErrors}
              setFieldErrors={setFieldErrors}
              subscriptionFormData={subscriptionFormData}
              setSubscriptionFormData={setSubscriptionFormData}
            />
            <div className="modalInnerFieldFooter flex justify-end">
              <button className="btnTheme btnPadding" onClick={handleOkClick}>
                OK
              </button>
            </div>
          </div>
        )}
      </ModalPopup>
    </>
  );
};

export default AwbTrackedListPage;